import { render } from "./controlsButton.vue?vue&type=template&id=66ad69aa&scoped=true"
import script from "./controlsButton.vue?vue&type=script&lang=js"
export * from "./controlsButton.vue?vue&type=script&lang=js"

import "./controlsButton.vue?vue&type=style&index=0&id=66ad69aa&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ad69aa"]])

export default __exports__